import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["planSelect", "employerContainer", "employerSelect"]
  static values = { planEmployers: Object }

  connect() {
    this.updateEmployers()
  }

  planChanged() {
    this.updateEmployers()
  }

  updateEmployers() {
    const planId = this.planSelectTarget.value
    const select = this.employerSelectTarget

    select.innerHTML = ""

    if (!planId) {
      this.employerContainerTarget.classList.add("hidden")
      return
    }

    const employers = this.planEmployersValue[planId] || []
    employers.forEach(e => {
      const option = document.createElement("option")
      option.value = e.id
      option.textContent = e.name
      select.appendChild(option)
    })

    if (employers.length > 1) {
      this.employerContainerTarget.classList.remove("hidden")
    } else {
      this.employerContainerTarget.classList.add("hidden")
    }
  }
}
